import { render, staticRenderFns } from "./failureUrl.vue?vue&type=template&id=38b20f2e&"
import script from "./failureUrl.vue?vue&type=script&lang=js&"
export * from "./failureUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports